import array from '@mailobj-browser/front/js/utils/array.js'
import contract from '@mailobj-browser/front/js/contracts/contract.js'
import init from "./draw/init.js";
import filters from "./draw/filters.js";
import color from "./draw/color.js";
import size from "./draw/size.js";
import tool from "./draw/tool.js";

//@TODO: Génériser ces contracts dans module-generics
export default contract({
  color: array([
    color
  ]),
  filters: array([
    filters
  ]),
  init: array([
    init
  ]),
  size: array([
    size
  ]),
  tool: array([
    tool
  ]),
})